<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.salonStylistReview')" />
      <v-tabs v-model="selectedTab" centered class="transparent">
        <v-tab class="text-h6 text-capitalize font-weight-bold tab">{{ $t('label.toReview') }}</v-tab>
        <v-tab class="text-h6 text-capitalize font-weight-bold tab">{{ $t('label.history') }}</v-tab>
      </v-tabs>
      <v-container class="rounded-lg my-8 pa-5 elevation-3" v-if="selectedTab === 0 && salonStylistToReview && salonStylistToReview.length > 0">
        <SalonStylistReviewListItem v-for="posTrasaction in salonStylistToReview" :posTrasaction="posTrasaction" :key="posTrasaction.pos_transaction_id" />
      </v-container>
      <div v-else-if="selectedTab === 0" class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('label.noRecords') }}</div>
      <v-container class="rounded-lg my-8 pa-5 elevation-3" v-if="selectedTab === 1 && history.length > 0">
        <SalonStylistReviewListItem v-for="posTrasaction in historyToDisplay" :posTrasaction="posTrasaction" :key="posTrasaction.pos_transaction_id" :toReview="false" />
        <Pagination v-model="historyToDisplay" :list="history" />
      </v-container>
      <div v-else-if="selectedTab === 1" class="blank-message text-h6 font-weight-medium grey--text text-center">{{ $t('label.noRecords') }}</div>
    </LayoutContent>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { REVIEW } from '@/api'
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
import SalonStylistReviewListItem from '@/components/review/SalonStylistReviewListItem.vue'
import Pagination from '@/components/Pagination.vue'

export default {
  components: { LayoutContent, SectionTitle, SalonStylistReviewListItem, Pagination },
  data() {
    return {
      selectedTab: '',
      history: [],
      historyToDisplay: []
    }
  },
  created() {
    // get to review
    this.fetchMyReviewSalonStylistToReview()

    // get history
    REVIEW.getMyReview({ type: 2, review_type: 2 }).then((res) => {
      if (res.total_count > 0) {
        this.history = res.list
      }
    })
  },
  computed: {
    ...mapState('review', ['salonStylistToReview'])
  },
  methods: {
    ...mapActions('review', ['fetchMyReviewSalonStylistToReview'])
  }
}
</script>

<style lang="scss">
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}
.tab {
  width: 50%;
}
</style>
<style lang="scss" scoped>
.blank-message {
  margin: 150px;
}
</style>
